
// Action types for creating a workflow route
export const CREATE_WORKFLOW_ROUTE_REQUEST = 'CREATE_WORKFLOW_ROUTE_REQUEST';
export const CREATE_WORKFLOW_ROUTE_SUCCESS = 'CREATE_WORKFLOW_ROUTE_SUCCESS';
export const CREATE_WORKFLOW_ROUTE_FAILURE = 'CREATE_WORKFLOW_ROUTE_FAILURE';




// Action types for fetching a workflow's routes using the workflow's id
export const FETCH_WORKFLOW_ROUTES_REQUEST = 'FETCH_WORKFLOW_ROUTES_REQUEST';
export const FETCH_WORKFLOW_ROUTES_SUCCESS = 'FETCH_WORKFLOW_ROUTES_SUCCESS';
export const FETCH_WORKFLOW_ROUTES_FAILURE = 'FETCH_WORKFLOW_ROUTES_FAILURE';




// Action types for updating routes of a workflow using the workflow's id
export const UPDATE_WORKFLOW_ROUTES_REQUEST = 'UPDATE_WORKFLOW_ROUTES_REQUEST';
export const UPDATE_WORKFLOW_ROUTES_SUCCESS = 'UPDATE_WORKFLOW_ROUTES_SUCCESS';
export const UPDATE_WORKFLOW_ROUTES_FAILURE = 'UPDATE_WORKFLOW_ROUTES_FAILURE';




// Action types for adding permissions to a workflow route or role using the workflow's id
export const ADD_WORKFLOW_ROUTE_PERMISSIONS_REQUEST = 'ADD_WORKFLOW_ROUTE_PERMISSIONS_REQUEST';
export const ADD_WORKFLOW_ROUTE_PERMISSIONS_SUCCESS = 'ADD_WORKFLOW_ROUTE_PERMISSIONS_SUCCESS';
export const ADD_WORKFLOW_ROUTE_PERMISSIONS_FAILURE = 'ADD_WORKFLOW_ROUTE_PERMISSIONS_FAILURE';





// Action types for fetching permissions of a workflow's routes or roles using the workflow's id
export const FETCH_WORKFLOW_ROUTE_PERMISSIONS_REQUEST = 'FETCH_WORKFLOW_ROUTE_PERMISSIONS_REQUEST';
export const FETCH_WORKFLOW_ROUTE_PERMISSIONS_SUCCESS = 'FETCH_WORKFLOW_ROUTE_PERMISSIONS_SUCCESS';
export const FETCH_WORKFLOW_ROUTE_PERMISSIONS_FAILURE = 'FETCH_WORKFLOW_ROUTE_PERMISSIONS_FAILURE';





// Action types for removing permissions from a workflow route or role using the workflow's id
export const REMOVE_WORKFLOW_ROUTE_PERMISSIONS_REQUEST = 'REMOVE_WORKFLOW_ROUTE_PERMISSIONS_REQUEST';
export const REMOVE_WORKFLOW_ROUTE_PERMISSIONS_SUCCESS = 'REMOVE_WORKFLOW_ROUTE_PERMISSIONS_SUCCESS';
export const REMOVE_WORKFLOW_ROUTE_PERMISSIONS_FAILURE = 'REMOVE_WORKFLOW_ROUTE_PERMISSIONS_FAILURE';


// Action types for workflow route actors
export const FETCH_WORKFLOW_ROUTE_ACTORS_REQUEST = 'FETCH_WORKFLOW_ROUTE_ACTORS_REQUEST';
export const FETCH_WORKFLOW_ROUTE_ACTORS_SUCCESS = 'FETCH_WORKFLOW_ROUTE_ACTORS_SUCCESS';
export const FETCH_WORKFLOW_ROUTE_ACTORS_FAILURE = 'FETCH_WORKFLOW_ROUTE_ACTORS_FAILURE';
